module.exports = __webpack_public_path__ + "img/contact-code-spring-300x300.b003a237.png";